var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPersonal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5F62\u72B6\u5907\u4EFD 10") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "62.4920423%",
    x2: "100%",
    y2: "62.4920423%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "20220317\\u7ECF\\u8425\\u60C5\\u51B5\\u5C55\\u793A",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F\\u5907\\u4EFD-46",
    transform: "translate(-663.000000, -490.000000)",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-19",
    transform: "translate(646.000000, 113.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-31\\u5907\\u4EFD-4",
    transform: "translate(0.000000, 370.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-18",
    transform: "translate(16.850000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.15,0.85 C14.139478,0.85 16.572421,3.27744792 16.572421,6.25939124 C16.572421,7.99029647 15.7453712,9.58128097 14.3974749,10.589017 L14.2014081,10.7289637 L14.097,10.796 L14.1381614,10.8067987 C14.7555134,10.9776349 15.3580976,11.2019859 15.9394685,11.4779442 L16.3714185,11.6945595 L16.724864,11.8897267 C20.1747367,13.8767019 22.3,17.5488771 22.3,21.5229848 C22.3,21.8378686 22.0675022,22.0984308 21.7646382,22.1432034 L21.6718301,22.15 L0.628169913,22.15 C0.281322324,22.15 0,21.869357 0,21.5229848 C0,17.5488771 2.12526328,13.8767019 5.57513595,11.8897267 C6.27513256,11.4865593 7.01314493,11.1623093 7.77694137,10.9204668 L8.202,10.795 L8.09813953,10.7283975 C6.77126552,9.82550594 5.90150098,8.37693286 5.75092955,6.76206404 L5.73317,6.50575811 L5.72757899,6.25939124 C5.72757899,3.27626864 8.15991102,0.85 11.15,0.85 Z M11.464,11.658 L11.3730872,11.6645583 L11.15,11.6690806 C11.0431727,11.6690806 10.9366938,11.6659815 10.8438924,11.6599918 C5.78358319,11.8125441 1.65913438,15.7775416 1.28424298,20.7792062 L1.277,20.895 L21.022,20.895 L21.0157577,20.7792168 C20.6476978,15.8686755 16.6653412,11.9570335 11.7310475,11.6706862 L11.464,11.658 Z M13.4659855,12.243552 C13.6602946,12.1316384 13.8996481,12.1316518 14.0939446,12.2435871 C14.2605673,12.3395794 14.3723624,12.5054077 14.4009034,12.6919681 L14.4081044,12.7867486 L14.4081044,17.0453023 C14.4081044,17.3916745 14.1267821,17.6723175 13.780126,17.6723174 C13.7065838,17.6724246 13.6338958,17.6595886 13.5653269,17.6347197 L13.4659709,17.5884905 L11.15,16.254 L8.83401448,17.5884989 C8.70447507,17.6631079 8.55491596,17.6879717 8.41203381,17.6630916 L8.30654126,17.6351045 L8.20605538,17.5884637 C8.03943271,17.4924715 7.9276376,17.3266431 7.8990966,17.1400828 L7.89189555,17.0453023 L7.89189555,12.7867486 C7.89189555,12.5626238 8.01166226,12.3555781 8.20605538,12.2435871 C8.36796917,12.1503077 8.56117247,12.1347518 8.73352337,12.1969224 L8.83401448,12.243552 L11.15,13.577 L13.4659855,12.243552 Z M13.151,13.872 L11.463949,14.8459594 C11.4315678,14.8646095 11.3979356,14.8801513 11.363469,14.8925846 L11.273,14.916 L11.3645893,14.9411264 L11.4640244,14.9873275 L13.151,15.96 L13.151,13.872 Z M9.148,13.872 L9.148,15.958 L10.83676,14.9847913 C10.8686366,14.9666622 10.901917,14.9514261 10.9361996,14.9391879 L11.024,14.916 L10.936487,14.8925596 L10.8359756,14.8459159 L9.148,13.872 Z M11.15,2.10403049 C8.85290967,2.10403049 6.98391882,3.96832994 6.98391882,6.25939124 C6.98391882,8.44509977 8.6907461,10.2589145 10.8508813,10.4052756 C11.0434629,10.3984545 11.2414484,10.3980182 11.4337588,10.4037868 C13.6091146,10.2588944 15.3160812,8.44554221 15.3160812,6.25939124 C15.3160812,3.96813632 13.4471951,2.10403049 11.15,2.10403049 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408"
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonal);
export default __webpack_public_path__ + "static/media/personal.f326f312c5cc5f1f356d789bd175c84f.svg";
export { ForwardRef as ReactComponent };